import { useEffect, useState } from "react";
import Button from "../../../../button/button";
import InputAnimated from "../../../../inputAnimated/inputAnimated"
import Modal from "../../../../modal/modal"
import Select from "../../../../select/select";
import SplitPay from "../PaymentConfirm/SplitPay/SplitPay";
import './changeReceiptPaymentMethod.scss'
import { PatchReceiptPaymentMethod } from "../../../../../utils/Apis/receptionApis";
import { dataDecrypt } from "../../../../../utils/dataDecrypt";
import { dataEncrpt } from "../../../../../utils/dataEncrypt";
const ChangeReceiptPaymentMethod = ({ isOpen, onClose, data, exchange, showAlert, setRefreshPaymentHistorySt }) => {
    const [paymentMethod, setPaymentMethod] = useState([]);
    const [isSplitRemaining, setIsSplitRemaining] = useState(false)
    const [selectedNewPaymentMethod, setSelectedNewPaymentMethod] = useState('')
    const [totalAmount, setTotalAmount] = useState(0);
    const [textTotalAmount, setTextTotalAmount] = useState(0);
    const [folio, setFolio] = useState('');
    const [actualPaymentMethod, setActualPaymentMethod] = useState('');
    const [buttonFinishPayment, setButtonFinishPayment] = useState(false)

    const currentExchange = exchange;
    useEffect(() => {
        if (isOpen) {
            const total = String(data.total_payed_amount)
                .split(',')
                .reduce((s, v) => s + (+v || 0), 0);
            setButtonFinishPayment(false)
            setTotalAmount(total)
            setTextTotalAmount(total)
            setFolio(`R${data.receipt_id}`)
            const paymentMethodArray = data.payment_method
            const methods = paymentMethodArray.map(pm => pm.name).join(', ');
            setActualPaymentMethod(methods);
            setSelectedNewPaymentMethod('')
            setPaymentMethod([])



        }
    }, [isOpen])

    const paymentOptions = [
        { value: "split", label: "Dividir pago" },
        { value: "EfectivoMXN", label: "Efectivo MXN", currency: 'MXN' },
        { value: "EfectivoUSD", label: "Efectivo USD", currency: 'USD' },
        { value: "Débito", label: "Débito", currency: 'MXN' },
        { value: "Crédito", label: "Crédito", currency: 'MXN' },
        { value: "Transferencia", label: "Transferencia", currency: 'MXN' },
    ];
    const handleChangePaymentMethod = async () => {
        setButtonFinishPayment(true)
        if (paymentMethod.length > 1) {
            if (isSplitRemaining) {
                setButtonFinishPayment(false)
                return showAlert('info', "Verifique que la cantidad a pagar sea la correcta");
            }
            // Verifica si hay efectivo MXN para dar cambio
            const hasZeroMethodPaymentAmount = paymentMethod.some(
                (m) => m.amount === '' || m.amount === '0.00' || m.amount === 0
            );
            if (hasZeroMethodPaymentAmount) {
                setButtonFinishPayment(false)
                return showAlert('danger', "Verifique nuevamente las cantidades de los metodos de pago, no puedo haber 0");
            }
        } else {
            if (paymentMethod.length > 0) {
                let method = paymentMethod[0]
                if ('rawAmount' in method) {
                    if (method.amount === '' || method.amount === '0.00' || method.amount === 0) {
                        setButtonFinishPayment(false)
                        return showAlert('danger', "Verifique nuevamente las cantidades de los metodos de pago");
                    }
                    if (paymentMethod.length === 1) {
                        setButtonFinishPayment(false)
                        return showAlert('danger', "Presione el boton <- regresar si desea solamente utilizar 1 solo metodo de pago");
                    }
                }
            }
        }


        const patchReceiptPaymentMethod = await PatchReceiptPaymentMethod(data.receipt_id, paymentMethod, currentExchange)
        if (patchReceiptPaymentMethod.status === 200) {
            const current = dataDecrypt(localStorage.getItem('alarmToCashAudit')) || 0;

            const newAmountForAlarm = current + patchReceiptPaymentMethod.amount_after_change;
            localStorage.setItem(
                'alarmToCashAudit',
                dataEncrpt(newAmountForAlarm)
            );
            setRefreshPaymentHistorySt(true)
            onClose()
            setButtonFinishPayment(false)
            showAlert('success', patchReceiptPaymentMethod.message)
        } else {
            setButtonFinishPayment(false)
            showAlert('danger', patchReceiptPaymentMethod.message)
        }

    }

    useEffect(() => {
        if (selectedNewPaymentMethod !== 'split') {
            const option = paymentOptions.find(
                v => v.value === selectedNewPaymentMethod
            );

            if (option) {
                let amountToEdit = totalAmount
                if (option.value === 'EfectivoUSD') {
                    amountToEdit = (amountToEdit / currentExchange).toFixed(2)
                }
                setTextTotalAmount(amountToEdit)
                setPaymentMethod([{
                    method: option.value,
                    amount: amountToEdit,
                    exchange: currentExchange,
                    currency: option.currency
                }]);
            }
        }
    }, [selectedNewPaymentMethod]);


    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <div className="change-receipt-pmethod-container">
                <h1 className="title-1">Cambiar metodo de pago</h1>
                <InputAnimated placeholder={'Folio'} value={folio} disabled={true}></InputAnimated>
                <InputAnimated placeholder={'Importe'} disabled={true} value={totalAmount}></InputAnimated>
                <InputAnimated placeholder={'Metodo de pago actual'} value={actualPaymentMethod} disabled={true}></InputAnimated>
                <Select options={paymentOptions} placeholder={'Selecciona nuevo metodo de pago'} value={selectedNewPaymentMethod} onChange={(e) => setSelectedNewPaymentMethod(e.target.value)}></Select>
                {selectedNewPaymentMethod === 'split' ?
                    <SplitPay
                        totalAmount={totalAmount}
                        exchange={currentExchange}
                        stateRemaining={setIsSplitRemaining}
                        setPaymentMethod={setPaymentMethod}
                    ></SplitPay> : <div className="change-receipt-pmethod-container-title-quantity">
                        <h1 className="title-2">Cantidad a pagar:</h1>
                        <h1 className="title-2">${textTotalAmount}</h1>
                    </div>}

                <div className="confirm-buttons-section">
                    <Button text={"Cancelar"} backgroundColor="red" onClick={onClose} disabled={buttonFinishPayment} />
                    <Button text="Confirmar" onClick={handleChangePaymentMethod} disabled={buttonFinishPayment || paymentMethod.length === 0} />
                </div>
            </div>
        </Modal>
    )
}
export default ChangeReceiptPaymentMethod